export function isNullOrEmpty(value) {
    if (typeof value == 'undefined') {
        return true;
    }
    if (value == '' || value == null || value == 'null') {
        return true;
    }
    return false;
}

